import { Partition, SceneObjects } from '@types'

export default function isPartition(partition?: SceneObjects | string): partition is Partition {
  if (typeof partition === 'string') return partition.startsWith('partition_')
  return !!partition && partition?.type === 'partition'
}
